// DS VSM - Dual-write bridge for DSCarmi to signals-based state management
import { createIdentifier } from '@wix/thunderbolt-ioc'
import type { DsVsmInstance } from './types'

export { initDSVsm } from './initDsVsm'
export { createDualWriteBridge } from './bridge'
export type { DsVsmInstance } from './types'

export const DsVsmSymbol = createIdentifier<DsVsmInstance>(Symbol('DsVsmInstance'))
